var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoziePurpleBlueLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 46,
    viewBox: "0 0 232 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Rozie-PurpleBlue-Logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M67.5105 33.6406V9.95744H78.2316C79.6161 9.94348 80.9809 10.286 82.1947 10.9521C83.3772 11.5842 84.3735 12.5151 85.0842 13.652C85.8346 14.8187 86.2245 16.1806 86.2052 17.5676C86.2065 18.9881 85.7404 20.3696 84.8789 21.499C83.9938 22.7065 82.7836 23.6374 81.3894 24.1831L87.2631 33.6564H82.5263L77.2052 24.7673H71.4263V33.6564L67.5105 33.6406ZM71.3947 21.2306H78.5631C79.0484 21.2446 79.5312 21.1562 79.9801 20.9712C80.429 20.7862 80.8338 20.5088 81.1684 20.157C81.5093 19.8003 81.7757 19.3792 81.952 18.9183C82.1282 18.4575 82.2107 17.9661 82.1947 17.4729C82.2114 16.9255 82.1019 16.3815 81.8747 15.8832C81.6474 15.3849 81.3085 14.9456 80.8842 14.5993C79.9512 13.8381 78.7716 13.4449 77.5684 13.4941H71.4263L71.3947 21.2306Z",
    fill: "#241032"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M107.379 33.988C105.698 34.0011 104.031 33.6902 102.468 33.0722C101.008 32.4843 99.6776 31.6153 98.5525 30.5144C97.4219 29.4253 96.5294 28.1135 95.9315 26.662C95.3074 25.1231 94.996 23.4753 95.0157 21.8148C94.9944 20.149 95.3057 18.4958 95.9315 16.9519C96.524 15.5052 97.4051 14.1944 98.5209 13.0994C99.6461 11.9986 100.977 11.1295 102.437 10.5416C105.597 9.32092 109.098 9.32092 112.258 10.5416C113.718 11.1371 115.048 12.0112 116.174 13.1152C117.281 14.223 118.161 15.5372 118.763 16.9834C119.983 20.0833 119.983 23.5305 118.763 26.6304C118.161 28.0767 117.281 29.3909 116.174 30.4986C115.048 31.6026 113.718 32.4767 112.258 33.0722C110.705 33.6851 109.049 33.9959 107.379 33.988ZM107.379 30.4355C108.901 30.4622 110.402 30.0747 111.721 29.3145C112.988 28.5578 114.021 27.4648 114.705 26.1567C115.438 24.8004 115.808 23.2774 115.779 21.7359C115.81 20.1891 115.44 18.6605 114.705 17.2992C114.021 15.9912 112.988 14.8982 111.721 14.1415C110.398 13.406 108.909 13.02 107.395 13.02C105.881 13.02 104.392 13.406 103.068 14.1415C101.825 14.8762 100.804 15.9349 100.116 17.2045C99.3716 18.5687 98.9961 20.1033 99.0262 21.6569C98.9981 23.2053 99.3736 24.7343 100.116 26.0936C100.804 27.3631 101.825 28.4218 103.068 29.1566C104.363 29.9652 105.853 30.4072 107.379 30.4355Z",
    fill: "#241032"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M127.921 33.6406V30.9723L141.8 13.4942H128.853V9.97327H147.09V12.61L133.274 30.1987H147.484V33.7038L127.921 33.6406Z",
    fill: "#241032"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M158.411 33.6406V30.1987H162.484V13.3521H158.411V9.97327H170.426V13.3521H166.353V30.1987H170.426V33.5775L158.411 33.6406Z",
    fill: "#241032"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M182.237 33.6407V9.95752H198.026V13.4784H186.058V19.7939H196.053V23.3148H186.058V30.1987H198.026V33.7038L182.237 33.6407Z",
    fill: "#241032"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M209.142 22.3832L214.353 9.97327H216.626L221.742 22.3832H219.089L217.953 19.5255H212.774L211.621 22.3832H209.142ZM214.353 15.3572L213.516 17.5677H217.211L216.311 15.3257L216.074 14.6625C215.963 14.3625 215.853 14.031 215.726 13.6678L215.379 12.6574C215.237 13.1152 215.063 13.5889 214.889 14.0941C214.716 14.5994 214.542 15.0099 214.353 15.3572Z",
    fill: "#241032"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M224.853 22.3832V20.3465H226.984V12.01H224.837V9.97327H231.595V12.01H229.416V20.3465H231.595V22.3832H224.853Z",
    fill: "#241032"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M45.8315 34.3827C45.4013 35.9061 44.4852 37.2473 43.2225 38.2021C41.9599 39.1569 40.4198 39.673 38.8368 39.672C38.2515 39.6766 37.668 39.6077 37.0999 39.4667C36.1511 39.268 35.2634 38.8458 34.5105 38.2352C33.8249 37.7228 33.2367 37.0918 32.7736 36.3721L32.3947 35.8195L28.4473 29.5829C27.7091 28.1776 26.6908 26.9385 25.4552 25.9419C24.2196 24.9453 22.7929 24.2124 21.2631 23.7885C18.6717 24.6609 15.9025 24.8672 13.2104 24.3884L21.1052 37.9352C27.7368 48.9873 45.5315 47.2822 45.9736 34.0038C45.9329 34.1325 45.8855 34.259 45.8315 34.3827Z",
    fill: "#844D9E"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M45.8315 34.3827C45.4013 35.9061 44.4852 37.2473 43.2225 38.2021C41.9599 39.1569 40.4198 39.673 38.8368 39.672C38.2515 39.6766 37.668 39.6077 37.0999 39.4667C36.1511 39.268 35.2634 38.8458 34.5104 38.2352C33.8249 37.7228 33.2367 37.0918 32.7736 36.3721L32.3947 35.8195L28.4473 29.5829C27.7091 28.1776 26.6908 26.9385 25.4552 25.9419C24.2196 24.9453 22.7929 24.2124 21.2631 23.7885C18.6717 24.6609 15.9025 24.8672 13.2104 24.3884L21.1052 37.9352C27.7368 48.9873 45.5315 47.2822 45.9736 34.0038C45.9329 34.1325 45.8855 34.259 45.8315 34.3827Z",
    fill: "url(#paint0_linear_4051_575)"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M0.594727 8.45756V27.2462C0.594727 34.2406 7.44736 37.0037 11.4737 37.0037V6.51554C10.2606 6.09275 8.98458 5.8792 7.69999 5.88399C5.09988 5.86389 2.5788 6.77704 0.594727 8.45756Z",
    fill: "#844D9E"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M0.594727 8.45756V27.2462C0.594727 34.2406 7.44736 37.0037 11.4737 37.0037V6.51554C10.2606 6.09275 8.98458 5.8792 7.69999 5.88399C5.09988 5.86389 2.5788 6.77704 0.594727 8.45756Z",
    fill: "url(#paint1_linear_4051_575)"
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M21.2316 23.7884C23.1863 23.1215 24.9004 21.892 26.1589 20.2544C27.4173 18.6168 28.1641 16.644 28.3053 14.5836C28.5264 5.75766 21.9895 0.578936 14.0948 0.578936C11.3469 0.570147 8.64677 1.29777 6.27536 2.68612C3.90396 4.07447 1.94788 6.07283 0.610596 8.47333C2.58568 6.76999 5.10769 5.83409 7.71586 5.8366C9.00045 5.8318 10.2765 6.04536 11.4895 6.46815C13.4359 7.14618 15.1113 8.43453 16.2663 10.1414C17.4214 11.8484 17.9944 13.8826 17.9001 15.9414C17.8378 17.6178 17.3753 19.255 16.5513 20.7162C15.7273 22.1774 14.5656 23.4203 13.1632 24.3411C15.8564 24.8378 18.6313 24.6477 21.2316 23.7884Z",
    fill: "#844D9E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M38.8368 37.0826C41.4093 37.0826 43.4947 34.9973 43.4947 32.4249C43.4947 29.8525 41.4093 27.7672 38.8368 27.7672C36.2644 27.7672 34.179 29.8525 34.179 32.4249C34.179 34.9973 36.2644 37.0826 38.8368 37.0826Z",
    fill: "#5759A7"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4051_575",
    x1: 31.7403,
    y1: 32.9142,
    x2: 21.8489,
    y2: 15.9096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#DEDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#B6B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#7F7D7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#3A3738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4051_575",
    x1: 6.2595,
    y1: 30.0176,
    x2: 5.64011,
    y2: -6.16898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#BAB9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#6C696A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#231F20"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoziePurpleBlueLogo);
export default __webpack_public_path__ + "static/media/rozie-purple-blue-logo.1d3f4e0f500b518caaac735b5b58a9eb.svg";
export { ForwardRef as ReactComponent };